// @flow

import { useAppSelector } from 'src/hooks/useAppSelector';

import {
  selectFilteredList,
  selectFilteredRawList,
  selectProvided,
} from '../../modules/selectors/results';

export function useSuggestedList(): {
  highlightedResult: void | string | false,
  suggestions: Array<string>,
} {
  const providedList = useAppSelector(selectProvided);

  const suggestions = useAppSelector(state =>
    selectFilteredList(state, 'popularity'),
  );

  const rawSuggestions = useAppSelector(state =>
    selectFilteredRawList(state, 'popularity'),
  );

  const hasProvidedResult = providedList && providedList.length > 0;

  const firstAvailable = rawSuggestions.find(
    suggestion => suggestion.availability === 'available',
  );

  const highlightedResult = !hasProvidedResult && firstAvailable?.fqdn;

  return {
    highlightedResult,
    suggestions: highlightedResult
      ? suggestions.filter(suggestion => suggestion !== highlightedResult)
      : suggestions,
  };
}
